/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { includes, isEmpty } from 'lodash';
import {
  InnerBanner,
  IframeVideo,
  BannerDescription,
  BannerHeading,
  BannerP,
} from './styles/InnerPageBanner.styled';
import { Container } from './styles/Container.styled';
import ScrollDownButton from './ScrollDownButton';
import { DWTCContext } from '../utils/context';
import InnerBannerSearchBar from './InnerBannerSearchBar';
import { InsightsProvider } from '../context/InsightsContext';
import DownloadCalendar from './DownloadCalendar';
import Events from '../services/Events';
import { getTranslationByKey } from '../helpers/translation-helper';

export default function VideoBanner({ data, id, dir }) {
  const { translations } = React.useContext(DWTCContext);
  const { cssClass } = React.useContext(DWTCContext);
  const isBrowser = typeof window !== 'undefined';
  const isEventsPage = isBrowser && window.location.pathname.includes('events');

  const events = new Events();

  const enEvents = events.get('en');
  const arEvents = events.get('ar');
  const allEvents =
    dir === 'rtl'
      ? arEvents.map((value) => {
          const tags = value.eventSectors.map((tag) => getTranslationByKey(translations, tag));
          return { ...value, eventSectors: tags };
        })
      : enEvents;

  return (
    <InnerBanner className={`video_section ${cssClass}`} dir={dir} id={id}>
      <IframeVideo className="video_banner">
        <iframe
          title="video"
          tabIndex="-1"
          src={data.videoUrl}
          className="vm-source"
          width="100%"
          height="100%"
          frameBorder="0"
          allowFullScreen=""
          data-deferred="true"
        />
      </IframeVideo>

      <BannerDescription className="description_banner" dir={dir}>
        <Container>
          <BannerHeading dir={dir}>{data.title}</BannerHeading>
          <BannerP dir={dir}>{data.text}</BannerP>
          {includes(cssClass, 'searchBar') && (
            <InsightsProvider>
              <InnerBannerSearchBar placeholder="What are you interested in?" />
            </InsightsProvider>
          )}
        </Container>
        {isEventsPage && !isEmpty(allEvents) && <DownloadCalendar dir={dir} events={allEvents} />}
      </BannerDescription>

      <ScrollDownButton position={data.jumpToSection} />
    </InnerBanner>
  );
}